import script from "./apply-choose-device.vue?vue&type=script&lang=ts&setup=true"
export * from "./apply-choose-device.vue?vue&type=script&lang=ts&setup=true"

import "./apply-choose-device.vue?vue&type=style&index=0&id=256adc37&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256adc37"]])

export default __exports__